import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import Modal from '../ui/Modal';
import AppLoadingOverlay from '../ui/AppLoadingOverlay';
import AddClientModal from './AddClientModal';

function dateOnly(value) {
  if (!value) return '';
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const date = typeof value.toDate === 'function' ? value.toDate() : new Date(value);
  return Number.isNaN(date.getTime()) ? '' : `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

function EditClientForm({ client, ...props }) {
  const [existingKyc, setExistingKyc] = useState(null);
  const [existingCv, setExistingCv] = useState({});
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setError(false);
    // The client card does not contain DOB/nationality. Load the same baseline
    // for a direct Edit drop and for a reused main-drop extraction.
    getDoc(doc(db, 'kyc', client.id)).then(snapshot => {
      if (!active) return;
      const data = snapshot.exists() ? snapshot.data() : {};
      const customer = data.customer || {};
      setExistingCv({ businessActivity: customer.businessActivity || '', sourceOfWealth: data.sourceOfFundsWealth?.sourceOfWealth || [] });
      const date = dateOnly(customer.dobOrIncorporationDate);
      setExistingKyc(client.clientType === 'entity'
        ? { incorporationDate: date }
        : { dateOfBirth: date, nationality: customer.nationalityOrIncorporationCountry || '' });
    }).catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [client.id, client.clientType, attempt]);

  if (!existingKyc) return <Modal open title="Edit Client" onClose={props.onClose} className="addClientModal"
    footer={error ? <button type="button" className="btn btn-sm btn-modal-save" onClick={() => setAttempt(value => value + 1)}>Retry</button> : null}>
    {error ? <p role="alert">The existing client details could not be loaded. Please retry before adding documents.</p>
      : <div style={{ position: 'relative', minHeight: 150 }}><AppLoadingOverlay title="Loading client details..." loaderStyle="dots" /></div>}
  </Modal>;
  return <AddClientModal {...props} client={client} mode="edit" existingKyc={existingKyc} existingCv={existingCv} />;
}

// Remount on every opening so a previous client's KYC cannot become the baseline.
export default function EditClientModal({ client, open, ...props }) {
  if (!open || !client?.id) return null;
  return <EditClientForm key={client.id} {...props} open client={client} />;
}
